/**
 * CheckBox.js
 * Created by calhosh on 7/13/2017.
 */
import React from 'react';
import styled from 'styled-components';
import MotifCheckbox from '@ey/motif-react-wrapper/Checkbox';
import EllipseControl from '../EllipsesControl/EllipsesControl';

export default function Checkbox(props) {
	const {
		id,
		label,
		name,
		inline,
		title,
		value,
		checked,
		disabled,
		dataAutoID,
		displayId,
		ellipse,
		noOfLines,
		styleName,
		className,
		customElement,
		statusLabel,
		titleForLabel,
		onChange,
		isAresView,
		indeterminate
	} = props;

	return (
		<StyledMotifCheckbox className={`StyledMotifCheckbox ${styleName ? styleName : ''}`}>
			<MotifCheckbox
				id={id ? id.toString() : id}
				name={name}
				inline={inline}
				value={value}
				onChange={onChange}
				checked={checked}
				disabled={disabled}
				className={className}
				data-autoid={dataAutoID}
				indeterminate={indeterminate}
			>
				{customElement && customElement}
				{!isAresView && ellipse ? (
					<EllipseControl content={label} tooltip={label} noOfLines={noOfLines} displayId={displayId} />
				) : (
					<span htmlFor={id}>{label}</span>
				)}
				{statusLabel && <span className="statusLabel">{statusLabel}</span>}
			</MotifCheckbox>
		</StyledMotifCheckbox>
	);
}

const StyledMotifCheckbox = styled.span`
	.motif-checkbox {
		.motif-checkbox-label {
			font-size: var(--px-16) !important;
		}
	}
`;
